'use strict';

var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};



//////////////////
// WEBPACK FOOTER
// ./~/escape-string-regexp/index.js
// module id = 1186
// module chunks = 4